<template>
    <v-container app :fluid="true">
        <v-row>
            <v-col cols="10">
                <v-card>
                    <v-card-title>
                        <v-text-field
                            v-model="search"
                            append-icon="fas fa-search"
                            label="Buscar unidad movil"
                            hide-details
                            class="wost-text-input"
                        ></v-text-field>
                        <v-spacer></v-spacer>
                        <v-btn @click="showCreateMobility()" 
                            rised 
                            color="indigo" 
                            dark height="36" 
                            class="wost-btn-new"
                            v-if="verifyPermission('crear_movilidades')"
                        >
                            <v-icon dark left size="12">fas fa-plus</v-icon>Nueva Unidad
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <div>
                            <v-data-table
                                class="wost-table"
                                :headers="headers"
                                :items="mobilities"
                                item-key="tuition_number"
                                height="65vh"
                                :search="search"
                                @click:row="handleClickRow"
                                v-if="verifyPermission('listar_movilidades')"
                            >
                                <template v-slot:item.tuition_number="{item}">
                                    {{ item.tuition_number }}
                                    <span :class="'status-' + item.status.toLowerCase()">{{ item.status }}</span>
                                </template>
                                <template v-slot:item.user_id="{ item }">
                                    <span v-if="item.user_id">
                                        {{ item.user.first_name }} {{ item.user.last_name }}
                                    </span>                                    
                                </template>

                                <template v-slot:item.action="{ item }">
                                    <div class="datatable-cell-wrapper">
                                        <a href="#" 
                                            title="Editar" 
                                            class="btn-actions btn-edit" 
                                            @click="editMobility(item)"
                                            v-if="verifyPermission('actualizar_movilidades')">
                                            <v-icon color="amber" size="16">fas fa-pencil-alt</v-icon>
                                        </a>
                                        &nbsp;
                                        <a v-if="item.status === 'activo' && verifyPermission('inactivar_movilidades')" 
                                            href="#" 
                                            title="Inactivar" 
                                            class="btn-actions btn-delete" 
                                            @click="deleteMobility(item, 'inactivar')">
                                            <v-icon color="red darken-1" size="16">fas fa-minus-circle</v-icon>
                                        </a>
                                        <a v-else-if="item.status.toLowerCase()  === 'inactivo' && verifyPermission('activar_movilidades')" 
                                            href="#" 
                                            title="Activar" 
                                            class="btn-actions btn-delete" 
                                            @click="deleteMobility(item, 'activar')">
                                            <v-icon color="green darken-1" size="16">fas fa-check-circle</v-icon>
                                        </a>
                                    </div>
                                </template>
                            </v-data-table>
                        </div>

                    </v-card-text>
                </v-card>

            </v-col>
            <v-col cols="2">
                <MobilityStadistic :stadistic="stadistic"></MobilityStadistic>
            </v-col>
        </v-row>


        <v-navigation-drawer
            v-model="drawer"          
            width="600"
            app
            temporary
            right
            class="wost-drawer"
            @input="handleChangeDrawer"
        >
            <div class="form-head">
                {{ titleForm }}
            </div>
            <div class="wrapper-form-crud overflow-y-auto">               
                <v-form>
                    <v-card class="padding-bootom-0">
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col :cols="12" class="space-inter-inputs">
                                        <v-text-field v-model="formMobility.tuition_number" label="Matricula" color="blue"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col :cols="12" class="space-inter-inputs">
                                        <v-text-field v-model="formMobility.brand" label="Marca"></v-text-field>
                                    </v-col>                                    
                                </v-row>
                                <v-row>
                                    <v-col :cols="12" class="space-inter-inputs">
                                        <v-text-field v-model="formMobility.color" label="Color"></v-text-field>
                                    </v-col>                                    
                                </v-row>
                                <v-row>
                                    <v-col :cols="12" class="space-inter-inputs">
                                        <v-text-field v-model="formMobility.type" label="Tipo"></v-text-field>
                                    </v-col>                                    
                                </v-row>
                                <v-row>
                                    <v-col :cols="12" class="space-inter-inputs">
                                        <v-autocomplete
                                        label="Repartidor"
                                        :items="delivery_users"
                                        v-model="formMobility.delivery_man"
                                        clearable>
                                        </v-autocomplete>
                                    </v-col>                                    
                                </v-row>
                            </v-container>
                        </v-card-text>

                    </v-card>
                    <br>
                    <v-divider></v-divider>
                    <br>
                    <div class="text-a-right">
                        <v-btn color="error" outlined @click="closeDrawer()" class="wost-btn-new">Cancelar</v-btn>
                        &nbsp;
                        <v-btn v-if="actionCrud === 'create'" color="primary" raised @click="addMobility()" class="wost-btn-new">Guardar</v-btn>
                        <v-btn v-else color="primary" raised @click="updateMobility()" class="wost-btn-new">Actualizar</v-btn>
                    </div>
                    
                </v-form>
            </div>
        </v-navigation-drawer>


    </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import MobilityDetail from './MobilityDetail'
import MobilityStadistic from './MobilityStadistic'
import {APIService} from '@/APIService';

import ApiUsers from '../../apis/User'

const apiService = new APIService();

export default {
    name: 'UnidadMovil',
    components: {
        MobilityStadistic
    },
    data() {
        return {
            drawer: false,
            titleForm: 'Nueva unidad movil',
            actionCrud: 'create',
            search: '',
            brand_search: null,
            brands: [
                { text: 'Marca A', value: 1},
                { text: 'Marca B', value: 2},
                { text: 'Marca C', value: 3},
            ],
            delivery_users: [],
            mobilities: [],
            headers: [
                { text: 'Matrícula', value: 'tuition_number', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Marca', value: 'brand', align: 'left', sortable: false, class: 'header-table', width: 120 },
                { text: 'Color', value: 'color', align: 'left', sortable: false, class: 'header-table', width: 140 },
                { text: 'Tipo', value: 'type', align: 'left', sortable: false, class: 'header-table', width: 110 },
                { text: 'Repartidor', value: 'user_id', align: 'left', sortable: false, class: 'header-table', width: 170 },
                { text: 'Acciones', value: 'action', sortable: false, class: 'header-table', width: 35 },
                { text: '', value: 'data-table-expand', width: 10, class: 'header-table-expand' }
            ],
            formMobility: {
                id: null,
                tuition_number: null,
                brand: null,
                color: null,
                type: null,
                delivery_man: null,
                user_name: null,
                change_user: false
            },
            stadistic: {
                orders_dispatched: null,
                drums_distributed: null,
                empty_drums_distributed: null,
                number_refills: null
            }
        }
    },
    methods: {
        clearForm() {
            this.titleForm = 'Nueva unidad movil'
            this.actionCrud = 'create'
            this.formMobility.id = null
            this.formMobility.tuition_number = null
            this.formMobility.brand = null
            this.formMobility.color = null
            this.formMobility.type = null
            this.formMobility.delivery_man = null
            this.formMobility.user_name = null
            this.formMobility.change_user = false
        },
        closeDrawer() {
            this.drawer = false
            this.clearForm()
        },
        showCreateMobility() {
            this.clearForm()
            this.getAvailableDeliveryUsers()
            this.drawer = !this.drawer
        },
        addMobility() {
            apiService.createMobility(this.formMobility).then((response) => {                
                this.drawer = false                
                this.mobilities.push(response.data)
                this.$notify({
                    title: 'Correcto',
                    message: 'Unidad movil registrado con éxito.',
                    type: 'success'
                });
            }).catch( function(error){
                console.log(error.response.data)
            });
        },
        editMobility(mobility) {
            this.titleForm = 'Editar unidad movil'
            this.actionCrud = 'update'
            this.formMobility.id = mobility.id
            this.formMobility.tuition_number = mobility.tuition_number
            this.formMobility.brand = mobility.brand
            this.formMobility.color = mobility.color
            this.formMobility.type = mobility.type
            this.formMobility.delivery_man = mobility.user_id
            if (mobility.user) {                
                this.delivery_users.push({
                    text: mobility.user.first_name + ' ' + mobility.user.last_name,
                    value: mobility.user.id
                })
            }            
            this.drawer = true
        },
        updateMobility() {
            apiService.updateMobility(this.formMobility.id, this.formMobility).then((response) => {
                this.clearForm()
                this.getAvailableDeliveryUsers()
                let index = this.findMobility(response.data)
                if (index > -1) {
                    this.mobilities.splice(index, 1, response.data);
                }       
                this.drawer = false;
            });
        },
        deleteMobility(mobility, status) {
            this.$swal({
                    title: "¿Desea confirmar?",
                    text: "Confirma que desea " + status + " la unidad movil",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Confirmar",
                    cancelButtonText: "Cancelar",
                }).then((result) => {
                    if(result.value){
                        if(result.value === true){
                            apiService.inactivateMobility(mobility.id).then((response) => {
                                let index = this.findMobility(response.data);
                                this.mobilities.splice(index, 1, response.data);                            
                            });
                        }
                    }                    
                })
        },
        findMobility(mobility) {
            let indexFounded = -1;
            this.mobilities.findIndex(function(element, index){
                if(element.id === mobility.id){
                    indexFounded = index
                }
            })

            return indexFounded
        },
        handleClickRow(value) {
            let mobilityId = value.id
            //buscar estadisticas por mobilidad
            this.stadistic.orders_dispatched = Math.floor((Math.random() * (30-10))+10)
            this.stadistic.drums_distributed = Math.floor((Math.random() * (30-10))+10)
            this.stadistic.empty_drums_distributed = Math.floor((Math.random() * (30-10))+10)
            this.stadistic.number_refills = Math.floor((Math.random() * (30-10))+10)
        },
        getAvailableDeliveryUsers(){
            ApiUsers.getAvailableDeliveryUsers().then((response) => {
                this.delivery_users = response.data;            
            });
        },
        handleChangeDrawer(value){
            if (!value) {
                this.getAvailableDeliveryUsers()
            }
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    },
    computed: {
        ...mapGetters('authentication', [
            'hasPermission',
        ]),
    },
    mounted() {
        apiService.getMobilities().then((response) => {
            this.mobilities = response.data
        });
        this.getAvailableDeliveryUsers()
    }
    
}
</script>

<style>

</style>